<script>
import { mapGetters } from 'vuex'
import Select from './BaseSelect'

export default {
  name: 'StoreSelect',
  extends: Select,

  props: {
    filterable: {
      type: Boolean,
      default: true
    },

    api: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    ...mapGetters({
      role: 'authentication/role',
      apiRole: 'authentication/apiRole'
    })
  },

  methods: {
    search (...args) {
      const service = this.$api[this.apiRole].getStores(...args)
      return service || Promise.reject(new Error('No handler provided'))
    },

    fetch (args) {
      const modifier = { ...args, 'q[store_id]': args.id }
      const service = this.$api[this.apiRole].getStores(modifier)
      return service || Promise.reject(new Error('No handler provided'))
    }
  }
}
</script>
